const selectors = {
  isFirstLogin: (state) => state.profile.isFirstLogin,
  selectedDancer: (state) => state.profile.selectedDancer,
  evaluation: (state) => state.profile.evaluation,
  rating: (state) => state.profile.rating,
  dancersList: (state) => state.profile.dancersList,
};

export { selectors };
